// Configuración de entorno dinámico
const isDevelopment = import.meta.env.DEV
const isProduction = import.meta.env.PROD

// Detectar si estamos en localhost o en el dominio de producción
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname.includes('localhost'))

// Configuración de URLs según el entorno
export const config = {
  // URL base de la API - apuntar directamente al backend en puerto 3002
  API_BASE_URL: isLocalhost ? 'http://localhost:3002/api' : 'https://vip.paraisotour.co/api',
  
  // Otras configuraciones
  WOMPI_API_URL: import.meta.env.VITE_WOMPI_API_URL || 'https://api.payouts.wompi.co/v1',
  WOMPI_API_KEY: import.meta.env.VITE_WOMPI_API_KEY,
  WOMPI_PRINCIPAL_USER_ID: import.meta.env.VITE_WOMPI_PRINCIPAL_USER_ID,
  
  // Flags de entorno
  isDevelopment,
  isProduction,
  isLocalhost
}

export default config
